import { render, staticRenderFns } from "./blockCoursePricing.vue?vue&type=template&id=1bf58c06&scoped=true&"
import script from "./blockCoursePricing.vue?vue&type=script&lang=js&"
export * from "./blockCoursePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf58c06",
  null
  
)

export default component.exports